
<router-outlet></router-outlet>
<!-- <ng-container *ngIf="!(permission_recoding | async)">
    <app-modal-permission></app-modal-permission>
</ng-container> -->
